import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TErrorBoxProps = {
  label?: string;
  children: ReactNode;
  className?: string;
};

export function ErrorBox({ label = "Error:", children, className }: TErrorBoxProps) {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-start rounded-[6px] bg-innoveraRed-50 px-[12px] py-[8px]",
        className
      )}
    >
      <p className="w-full text-[14px] leading-[22px] text-innoveraRed-700">
        <span className="font-semibold text-innoveraRed-400">{label}</span>
        <span className="ml-1">{children}</span>
      </p>
    </div>
  );
}
